<template>

    <div>
        <section class="contact-used">
            <div class="ink-grid">
                <div class="nav small half-vertical-padding">
                    <a href="#" onclick="history.back()"><i class="fas fa-chevron-left"></i> Voltar a detalhe</a>
                </div>
                <div class="has-sidebar clearfix">

                    <div class="content card" v-if="showForm">
                        <fieldset v-if="propIsLogged == false" class="row mb-3 border-top border-bottom">
                            <div class="col-12 py-2 pl-0" style="font-size: 15px;line-height: 21px;">
                                <p class="mb-0">Para uma melhor experiência e acesso ao histórico das mensagens, recomendamos que inicie sessão na sua conta.</p>
                                <p class="mb-0">Faça <a :href="urlLogin" class="text-primary">Login</a> ou <a :href="urlLogin" class="text-primary">Registe-se</a>.</p>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>Contactar vendedor</legend>
                        </fieldset>

                        <fieldset v-if="propIsLogged == false">
                            <div class="column-group half-gutters">
                                <div class="control-group required all-70 tiny-100 small-100 medium-100 large-100" :class="getFieldClass('Name')">
                                    <label for="name">Nome</label>
                                    <div class="control">
                                        <input id="name" name="name" v-model="name" type="text">
                                    </div>
                                    <error-for-component field="Name" :field-value="name" :errors="errorList"></error-for-component>
                                </div>
                                <div class="control-group required all-45 tiny-100 small-100 medium-60 large-70" :class="getFieldClass('Email')">
                                    <label for="name">Email</label>
                                    <div class="control">
                                        <input id="email" name="email" v-model="email" type="text">
                                    </div>
                                    <error-for-component field="Email" :field-value="email" :errors="errorList"></error-for-component>
                                </div>
                                <div class="control-group all-25 tiny-100 small-100 medium-40 large-30" :class="getFieldClass('Mobile')">
                                    <label for="phone">Telemóvel</label>
                                    <div class="control">
                                        <input id="phone" name="phone" v-model="phone" type="text">
                                    </div>
                                    <error-for-component field="Mobile" :field-value="phone" :errors="errorList"></error-for-component>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <div class="control-group half-gutters">
                                <div class="control-group required all-70 small-100 tiny-100"
                                    v-bind:class="{ 'validation-error': showContactOptionMessageError }">
                                    <label for="ContactOptions">Mensagem</label>
                                    <div class="control">
                                        <select id="ContactOptions" class="selectpicker squared show-tick"
                                            title="Escolha..." data-style="ink-button" data-width="100%"
                                            v-model="selectedOption" @change="onOptionsChanged">
                                            <option v-for="item in this.contactOptions" v-bind:key="item.Key"
                                                v-bind:value="item.Key">
                                                {{ item.Value }}</option>
                                        </select>
                                    </div>
                                    <p class="error">{{ contactOptionMessageError }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset v-if="selectedOption == 99">
                            <div class="column-group half-gutters">
                                <div class="control-group required all-100"
                                    v-bind:class="{ 'validation-error': showContactMessageError }">
                                    <label for="message">Mensagem</label>
                                    <div class="control half-bottom-space">
                                        <textarea id="message" v-model="contactMessage"></textarea>
                                    </div>
                                    <p class="error">{{ contactMessageError }}</p>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <div class="column-group gutters">

                                <div class="control-group all-50 small-100 tiny-100">
                                    <div class="control check-group medium">
                                        <input id="retomaInput" type="checkbox" v-model="hasRetoma">
                                        <label class="section-collapse collapsed" for="retomaInput"
                                            data-toggle="collapse" href="#retoma" role="button"
                                            aria-expanded="false"><span>Tem retoma?</span></label>
                                    </div>

                                    <div class="collapse box framed" id="retoma">
                                        <div class="control-group"
                                            v-bind:class="{ 'validation-error': showRetomaPlateMessageError }">
                                            <label for="PlateStart">Matrícula</label>
                                            <div class="control plate">
                                                <input class="plate-input" id="PlateStart" maxlength="2" minlength="2"
                                                    name="PlateStart" size="2"
                                                    title="Introduza dois caracteres entre A-Z ou 0-9." type="text"
                                                    v-model="retomaMessage.plateStart">
                                                <input class="plate-input" id="PlateMid" maxlength="2" minlength="2"
                                                    name="PlateMid" size="2"
                                                    title="Introduza dois caracteres entre A-Z ou 0-9." type="text"
                                                    v-model="retomaMessage.plateMid">
                                                <input class="plate-input" id="PlateEnd" maxlength="2" minlength="2"
                                                    name="PlateEnd" size="2"
                                                    title="Introduza dois caracteres entre A-Z ou 0-9." type="text"
                                                    v-model="retomaMessage.plateEnd">
                                            </div>
                                            <p class="error">{{ retomaPlateMessageError }}</p>
                                        </div>

                                        <div class="control-group"
                                            v-bind:class="{ 'validation-error': showRetomaKilometerMessageError }">
                                            <label for="Kms">Quilómetros</label>
                                            <div class="control all-100">
                                                <input id="Kms" name="Kms" type="text"
                                                    v-model.lazy="retomaMessage.kilometer">
                                            </div>
                                            <p class="error">{{ retomaKilometerMessageError }}</p>
                                        </div>

                                    </div>
                                </div>

                                <div class="control-group all-50 small-100 tiny-100">
                                    <div class="control check-group medium">
                                        <input id="financiamentoInput" type="checkbox" v-model="hasFinancing">
                                        <label class="section-collapse collapsed" for="financiamentoInput"
                                            data-toggle="collapse" href="#financiamento" role="button"
                                            aria-expanded="false"><span>Pretende financiamento?</span></label>
                                    </div>

                                    <div class="collapse box framed" id="financiamento">
                                        <div class="control-group"
                                            v-bind:class="{ 'validation-error': showFinancingIncomingMessageError }">
                                            <label for="EntryValue">Valor de entrada</label>
                                            <div class="control all-100 euro">
                                                <input id="EntryValue" name="EntryValue" type="text"
                                                    v-model.lazy="financiamentoMessage.incoming">
                                            </div>
                                            <p class="error">{{ financingIncomingMessageError }}</p>
                                        </div>

                                        <div class="control-group"
                                            v-bind:class="{ 'validation-error': showFinancingMontlyPaymMessageError }">
                                            <label for="MonthlyPayment">Mensalidade</label>
                                            <div class="control all-100 euro">
                                                <input id="MonthlyPayment" name="MonthlyPayment" type="text"
                                                    v-model.lazy="financiamentoMessage.montlyPayment">
                                            </div>
                                            <p class="error">{{ financingMontlyPaymMessageError }}</p>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </fieldset>

                        <fieldset v-if="propIsLogged == false">
                            <div class="control-group" :class="getFieldClass('AcceptTermsAndConditions')">
                                <ul class="control check-group medium">
                                    <li>
                                        <input id="Contact_GDPR_AcceptTermsAndConditions"
                                            name="GDPR.AcceptTermsAndConditions" type="checkbox" value="true"
                                            v-model="AcceptTermsAndConditions">
                                        <label for="Contact_GDPR_AcceptTermsAndConditions">
                                            <span>Os dados pessoais recolhidos no presente formulário serão tratados com o objetivo de dar resposta ao seu pedido de informação e possibilitar o contato dos anunciantes. Para mais informações sobre o tratamento dos seus dados, consulte a nossa <a href="https://ajuda.sapo.pt/politica-de-privacidade-7675?utm_source=bsu&utm_medium=web&utm_campaign=bsu_footer&utm_content=auto.sapo.pt](https://ajuda.sapo.pt/politica-de-privacidade-7675?utm_source=bsu&utm_medium=web&utm_campaign=bsu_footer&utm_content=auto.sapo.pt" target="_blank">Política de Privacidade</a><i class="fa fa-asterisk m-1" style="font-size: 10px"></i></span>
                                        </label>
                                    </li>
                                </ul>
                                <error-for-component field="AcceptTermsAndConditions"
                                    :field-value="AcceptTermsAndConditions" :errors="errorList"></error-for-component>
                            </div>
                            
                            <div class="control-group" :class="getFieldClass('Captcha')">
                                <div class="control">
                                    <div id="captcha_turnstile" class="all-100 cf-turnstile"></div>
                                </div>
                                <error-for-component field="Captcha"
                                        :errors="errorList"></error-for-component>
                            </div>

                        </fieldset>

                        <div class="all-100 half-vertical-space">
                            <div class="push-right">
                                <button class="ink-button main-action min-width" :disabled="showPageLoader"
                                    v-on:click="Send" type="button">Enviar <i class="fas fa-circle-notch fa-spin" v-if="showPageLoader"></i></button>
                            </div>
                            <small><i class="fas fa-asterisk"></i> Campos obrigatórios</small>

                        </div>
                    </div>

                    <div v-else class="content card bottom-space contact-resume">
                        <i class="far fa-check-circle"></i>
                        <h3>Mensagem enviada com sucesso!</h3>
                        <p class="bottom-space">Em breve, irá receber um email de confirmação com os detalhes da viatura e informações sobre o anunciante.
                        </p>
                        <div>
                            <a v-if="this.propIsLogged" :href="goToMessage" class="ink-button">Ver mensagem</a>
                            <a v-else href="#" class="ink-button" onclick="history.back()">Voltar ao detalhe</a>
                            
                            <a :href="goToSearch()" class="ink-button main-action" >Ver mais carros</a>
                        </div>
                    </div>
                    <aside>
                        <vehicleResume contactPage="true" :ad-details=this.propAdData></vehicleResume>
                    </aside>

                </div>
            </div>

        </section>

        <section class="suggested top-space"></section>
    </div>

</template>

<script>

import notifications from "../scripts/notifications";
import leadsClient from '../scripts/services/leadsClient';
import VehicleCard from '../shared/vehicle-card.vue';
import ErrorForComponent from '../shared/error-for.vue';
import * as utils from '../scripts/utils.js';
import vehicleResume from './vehicle-resume.vue';

export default {
    data() {
        return {
            showPageLoader: false,
            name: '',
            email: '',
            phone: '',
            AcceptTermsAndConditions: false,
            AcceptRgpd: false,
            AcceptNewsletterAUTO: false,
            showForm: true,
            contactMessage: '',
            selectedOption: 1,
            contactOptions: [
                { Key: 1, Value: "Pretendo saber mais informações sobre esta viatura." },
                { Key: 2, Value: "Pretendo agendar um test-drive a esta viatura." },
                { Key: 3, Value: "Pretendo agendar uma visita ao Ponto de Venda." },
                { Key: 99, Value: "Personalizar mensagem" }
            ],
            hasRetoma: false,
            retomaMessage: {
                plateStart: '',
                plateMid: '',
                plateEnd: '',
                kilometer: '',
                toString() {
                    return "Retoma: \nMatricula: " + this.plateStart + "-" + this.plateMid + "-" + this.plateStart + "\nQuilómetros: " + this.kilometer
                }
            },
            hasFinancing: false,
            financiamentoMessage: {
                incoming: '',
                montlyPayment: '',
                toString() {
                    return "Proposta de Financiamento: \nEntrada: " + this.incoming + "€\nMensalidade: " + this.montlyPayment + "€"
                }
            },
            contactMessageError: "",
            retomaPlateMessageError: "",
            retomaKilometerMessageError: "",
            financingIncomingMessageError: "",
            financingMontlyPaymMessageError: "",
            contactOptionMessageError: "",
            showContactMessageError: false,
            showRetomaPlateMessageError: false,
            showRetomaKilometerMessageError: false,
            showFinancingIncomingMessageError: false,
            showFinancingMontlyPaymMessageError: false,
            showContactOptionMessageError: false,
            errorList: [],

            leadId: 0,
            isNewLead: true,

            urlLogin: "/account/signin?url=" + window.location.href
        }
    },
    components: {
        vehicleResume,
        VehicleCard,
        ErrorForComponent
    },
    props: {
        propIdPub: String,
        propIsLogged: Boolean,
        propAdData: Object,
        propSearchUrl: String,
        dataSiteKey: {
            type: String,
            default: ""
        }
    },
    mounted() {
        this.propAdData = JSON.parse(this.propAdData);

        this.onOptionsChanged();

        let selectedOption = this.selectedOption;

        $(document).ready(function () {
            $(".plate-input").keyup(function () {
                if (this.value.length == this.maxLength) {
                    $(this).next('.plate-input').focus();
                }
            });

            $("#Kms").mask("#.##0", { reverse: true });
            $("#EntryValue").mask("#.##0", { reverse: true });
            $("#MonthlyPayment").mask("#.##0", { reverse: true });

            $("#ContactOptions").val(selectedOption);
            $("#ContactOptions").selectpicker('refresh');
        })

        let captchaElement = document.getElementById("captcha_turnstile");
        
        if (captchaElement) {
            captchaElement.setAttribute("data-sitekey", this.dataSiteKey);
        }
    },

    methods: {
        async onOptionsChanged() {
            if (this.selectedOption == 0
                || this.selectedOption == 99) {
                this.contactMessage = "";
            } else {
                this.contactMessage = this.contactOptions.filter(i => i.Key == this.selectedOption)[0].Value;
            }

            this.contactOptionMessageError = "";
            this.showContactOptionMessageError = false;

            this.contactMessageError = "";
            this.showContactMessageError = false;
        },
        getMessages() {
            let message = this.contactMessage;

            if (this.hasRetoma) {
                //check if its ok
                message = message + "\n\n" + this.retomaMessage.toString();
            }

            if (this.hasFinancing) {
                //check if its ok
                message = message + "\n\n" + this.financiamentoMessage.toString();
            }

            let messages = [{
                Body: message
            }];

            return messages;
        },
        IsContactMessageValid() {
            let valid = this.contactMessage != null && this.contactMessage.trim() != "";
            if (!valid) {
                this.contactMessageError = "Campo obrigatório";
                this.showContactMessageError = true;
            } else {
                this.contactMessageError = "";
                this.showContactMessageError = false;
            }
            return valid;
        },
        IsRetomaMessageValid() {
            let valid = true;
            if (this.hasRetoma) {
                if (this.retomaMessage.plateStart == "" ||
                    this.retomaMessage.plateMid == "" ||
                    this.retomaMessage.plateEnd == "") {
                    this.retomaPlateMessageError = "Campo obrigatório";
                    valid = false;
                    this.showRetomaPlateMessageError = true;
                } else { this.retomaPlateMessageError = ""; this.showRetomaPlateMessageError = false; }

                if (this.retomaMessage.kilometer == "") {
                    this.retomaKilometerMessageError = "Campo obrigatório";
                    valid = false;
                    this.showRetomaKilometerMessageError = true;
                } else { this.retomaKilometerMessageError = ""; this.showRetomaKilometerMessageError = false; }
            }
            return valid;
        },
        IsFinancingMessageValid() {
            let valid = true;
            if (this.hasFinancing) {
                if (this.financiamentoMessage.incoming == "") {
                    this.financingIncomingMessageError = "Campo obrigatório";
                    valid = false;
                    this.showFinancingIncomingMessageError = true;
                } else { this.financingIncomingMessageError = ""; this.showFinancingIncomingMessageError = false; }

                if (this.financiamentoMessage.montlyPayment == "") {
                    this.financingMontlyPaymMessageError = "Campo obrigatório";
                    valid = false;
                    this.showFinancingMontlyPaymMessageError = true;
                } else { this.financingMontlyPaymMessageError = ""; this.showFinancingMontlyPaymMessageError = false; }
            }
            return valid;
        },
        IsSelectedOptionValid() {
            let valid = this.selectedOption != 0;
            if (!valid) {
                this.contactOptionMessageError = "Campo obrigatório";
                this.showContactOptionMessageError = true;
            } else {
                this.contactOptionMessageError = "";
                this.showContactOptionMessageError = false;
            }
            return valid;
        },
        IsFormValid() {
            return this.IsSelectedOptionValid() & this.IsContactMessageValid() & this.IsRetomaMessageValid() & this.IsFinancingMessageValid();
        },
        getFieldClass(field) {
            return utils.GetErrorClass(this.errorList, field);
        },
        Send: async function () {
            if (this.IsFormValid()) {
                this.showPageLoader = true;
                var formToSend = {
                    IdAdPub: this.propIdPub,
                    IdPublicProcurementRequest: this.propAdData.AdvertInfo != null ? this.propAdData.AdvertInfo.IdPublicProcurementRequest : null,
                    Price: this.propAdData != null && this.propAdData.AdvertInfo != null && this.propAdData.AdvertInfo.NewPrice != null ?
                        this.propAdData.AdvertInfo.NewPrice : this.propAdData.Price.Total,
                    Messages: this.getMessages()
                };

                // if user is not logged
                if (this.propIsLogged == false) {
                    formToSend.GuestUser = {
                        Name: this.name,
                        Email: this.email,
                        Mobile: this.phone,
                        AcceptTermsAndConditions: this.AcceptTermsAndConditions,
                        AcceptRgpd: this.AcceptTermsAndConditions,
                    }
                    
                    const inputElement = document.querySelector('input[name="cf-turnstile-response"]');
                    if (inputElement) {
                        formToSend.Token = inputElement.value
                    }
                }

                let result = await leadsClient.CreateLeadFromAd(formToSend);
                if (result) {
                    if (result.Success) {
                        this.showForm = false;
                        this.leadId = result.Result.Id;
                        this.isNewLead = result.Result.IsNewLead;
                        window.scrollTo(0,0);
                    } else {
                        if (result.Errors != null && result.Errors.length > 0) {
                            if (result.Errors != null && result.Errors.length > 0) {
                                this.errorList = result.Errors;

                                if (result.Errors.filter(e => e.Field == "Captcha"))
                                {
                                    try{
                                        turnstile.reset(this.dataSiteKey);
                                    }catch(e){
                                        //ignore
                                        console.log(e);
                                    }
                                }
                            }
                        }
                        else {
                            notifications.Error('Contactar', "Ocorreu um erro inesperado. Tente novamente.");
                            try{
                                turnstile.reset(this.dataSiteKey);
                            }catch(e){
                                //ignore
                                console.log(e);
                            }
                        }
                    }
                }

                this.showPageLoader = false;
            }
        },
        goToSearch(){
            if (this.propSearchUrl && this.propSearchUrl != null){
                return this.propSearchUrl;
            }else{
                return "/carros-usados";
            }
        }
    },
    computed: {
        goToMessage: function(){
            if (this.leadId > 0){
                if (this.isNewLead){
                    return "/user/messages/" + this.leadId;
                }
                else {
                    return "/user/messages/" + this.leadId + "?hasContactedBefore=true";
                }
            }else{
                return "/user/messages/";
            }
        }
    },
    watch: {
        'contactMessage'(newValue, oldValue) {
            if (this.showContactMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showContactMessageError = false;
                    this.contactMessageError = "";
                }
            }
        },
        'retomaMessage.plateStart'(newValue, oldValue) {
            if (this.showRetomaPlateMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showRetomaPlateMessageError = false;
                    this.retomaPlateMessageError = "";
                }
            }
        },
        'retomaMessage.plateMid'(newValue, oldValue) {
            if (this.showRetomaPlateMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showRetomaPlateMessageError = false;
                    this.retomaPlateMessageError = "";
                }
            }
        },
        'retomaMessage.plateEnd'(newValue, oldValue) {
            if (this.showRetomaPlateMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showRetomaPlateMessageError = false;
                    this.retomaPlateMessageError = "";
                }
            }
        },
        'retomaMessage.kilometer'(newValue, oldValue) {
            if (this.showRetomaKilometerMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showRetomaKilometerMessageError = false;
                    this.retomaKilometerMessageError = "";
                }
            }
        },
        'financiamentoMessage.incoming'(newValue, oldValue) {
            if (this.showFinancingIncomingMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showFinancingIncomingMessageError = false;
                    this.financingIncomingMessageError = "";
                }
            }
        },
        'financiamentoMessage.montlyPayment'(newValue, oldValue) {
            if (this.showFinancingMontlyPaymMessageError) {
                if (newValue != undefined && newValue != "" && newValue != oldValue) {
                    this.showFinancingMontlyPaymMessageError = false;
                    this.financingMontlyPaymMessageError = "";
                }
            }
        }
    },

};

</script>